import { doc, setDoc } from "firebase/firestore";
import { db } from "../../firebase";

const ApproveUser = (uid) => {
  let DocRef = doc(db, "Users", uid);

  try {
    setDoc(
      DocRef,
      {
        IsVerified: 1,
      },
      { merge: true }
    );
    return true;
  } catch (error) {
    return false;
  }
};

export default ApproveUser;
